import { render, staticRenderFns } from "./PageEditorToolbarSectionBtn.vue?vue&type=template&id=326ce770&scoped=true"
import script from "./PageEditorToolbarSectionBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorToolbarSectionBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326ce770",
  null
  
)

export default component.exports